import { render, staticRenderFns } from "./VacancyAiQuestionsEdit.vue?vue&type=template&id=f7f0a116&scoped=true&"
import script from "./VacancyAiQuestionsEdit.vue?vue&type=script&lang=js&"
export * from "./VacancyAiQuestionsEdit.vue?vue&type=script&lang=js&"
import style0 from "./VacancyAiQuestionsEdit.vue?vue&type=style&index=0&id=f7f0a116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f0a116",
  null
  
)

/* custom blocks */
import block0 from "./VacancyAiQuestionsEdit.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyAiQuestionsEdit.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VRow})
